/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  familyHousingTypes,
  familyHouseTypes,
  liveWithPerson,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
  prevForm,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"
const Family = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    activeIndex,
    sections,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [family, setFamily] = useState(interview[INTERVIEW_SECTIONS.FAMILY])
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.FAMILY &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.FAMILY
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.FAMILY, family)
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_FAMILY_DATA, {
          GpraC1: family?.gpra_c_1,
          GpraC1a: family?.gpra_c_1a,
          GpraC1b: family?.gpra_c_1b,
          GpraC2: family?.gpra_c_2,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraCId: family?.gpra_c_id,
          Additional: getAdditionalQuestions(family),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.FAMILY, {
                ...family,
                gpra_c_id: response.data.gpraCId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ family: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const validForm = () => {
    const errors = {}
    if (!family?.gpra_c_1 && showQuestion(questions, "gpra_c_1")) {
      errors.gpra_c_1 = errorMessages.requiredMessage
    } else if (family?.gpra_c_1 === "Housed") {
      if (!family?.gpra_c_1a) {
        errors.gpra_c_1a = errorMessages.requiredMessage
      } else if (family?.gpra_c_1a === "Other housed") {
        if (!family?.gpra_c_1b) {
          errors.gpra_c_1b = errorMessages.requiredMessage
        }
      }
    }
    if (!family?.gpra_c_2 && showQuestion(questions, "gpra_c_2")) {
      errors.gpra_c_2 = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        family,
        INTERVIEW_SECTIONS.FAMILY,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_c_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. In the past 30 days, where have you been living most of the time? [DO NOT READ RESPONSE OPTIONS TO CLIENT.]`}
              required
            />
            <Dropdown
              disabled={disabled}
              className={
                validationErrors.gpra_c_1
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={family?.gpra_c_1}
              onChange={(e) => {
                updateState(
                  "gpra_c_1",
                  e.value,
                  null,
                  null,
                  family,
                  setFamily,
                  [
                    { key: "gpra_c_1a", value: "" },
                    { key: "gpra_c_1b", value: "" },
                  ]
                )
                removeError("gpra_c_1")
                removeError("gpra_c_1a")
                removeError("gpra_c_1b")
              }}
              options={familyHouseTypes}
              showClear={family?.gpra_c_1}
              optionLabel="label"
              optionValue="value"
            />
            <FormError error={validationErrors.gpra_c_1} />
          </div>
          {family?.gpra_c_1 === "Housed" && (
            <>
              <div className={gpraStyles.formRow}>
                <FormLabel label={"If housed"} left={"1"} required/>
                <Dropdown
                  disabled={disabled || family?.gpra_c_1 !== "Housed"}
                  className={
                    validationErrors.gpra_c_1a
                      ? gpraStyles.input5Error
                      : gpraStyles.input5
                  }
                  value={family?.gpra_c_1a}
                  onChange={(e) => {
                    updateState(
                      "gpra_c_1a",
                      e.value,
                      null,
                      null,
                      family,
                      setFamily,
                      [{ key: "gpra_c_1b", value: "" }]
                    )
                    removeError("gpra_c_1b")
                    removeError("gpra_c_1a")
                  }}
                  options={familyHousingTypes}
                  showClear={family?.gpra_c_1a}
                  optionLabel="label"
                  optionValue="value"
                />
                <FormError error={validationErrors.gpra_c_1a} />
              </div>
              {family?.gpra_c_1 === "Housed" &&
                family?.gpra_c_1a === "Other housed" && (
                  <div className={gpraStyles.formRow}>
                    <FormLabel label={"Other Housed (Specify)"} />
                    <InputText
                      className={
                        validationErrors.gpra_c_1b
                          ? gpraStyles.inputText5Error
                          : gpraStyles.inputText5
                      }
                      disabled={
                        family?.gpra_c_1a !== "Other housed" || disabled
                      }
                      placeholder={
                        family?.gpra_c_1a !== "Other housed"
                          ? "Not Applicable"
                          : ""
                      }
                      value={family?.gpra_c_1b}
                      onChange={(e) => {
                        updateState(
                          "gpra_c_1b",
                          e.target.value,
                          null,
                          null,
                          family,
                          setFamily,
                          null
                        )
                        removeError("gpra_c_1b")
                      }}
                    />
                    <FormError error={validationErrors.gpra_c_1b} />
                  </div>
                )}
            </>
          )}
        </>
      )
    }
    if (question.field === "gpra_c_2") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Do you currently live with any person who, over the past 30 days, has regularly used alcohol or other substances?`}
            required
          />
          <Dropdown
            disabled={disabled}
            className={
              validationErrors.gpra_c_2
                ? gpraStyles.input5Error
                : gpraStyles.input5
            }
            value={family?.gpra_c_2}
            onChange={(e) => {
              updateState(
                "gpra_c_2",
                e.value,
                null,
                null,
                family,
                setFamily,
                null
              )
              removeError("gpra_c_2")
            }}
            options={liveWithPerson}
            showClear={family?.gpra_c_2}
            optionLabel="label"
            optionValue="value"
          />
          <FormError error={validationErrors.gpra_c_2} />
        </div>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="C. LIVING CONDITIONS" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={family}
                    setEntity={setFamily}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.FAMILY}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, family)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={family}
                      setEntity={setFamily}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.FAMILY}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </div>
  )
}

Family.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Family.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Family
